import { AppLanguages } from 'interfaces'
import { i18nManager, SUPPORTED_LANGS } from './../i18n'

export const getFormatLang = (lang = 'en-US'): string => {
  const formatLangMapper = {
    'es-': 'de-DE',
    'pr-': 'fr-FR',
  }

  Object.keys(formatLangMapper).forEach((key) => {
    if (lang.includes(key, 0)) lang = formatLangMapper[key]
  })

  return lang
}

export const getLang = (): string => {
  return SUPPORTED_LANGS?.find(
    (i) => i?.apiLanguage === (i18nManager.getAppLang() || AppLanguages.en),
  )?.code
}
